import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { getAnimDistance } from '../../utils';
import { getAbsoluteSetupArray, getAbsoluteSetupCSS, isMobileWidth, } from '../globalUtils';
const ease = 'cubic-bezier(.01,.09,.06,.99)';
const opacityEase = 'cubic-bezier(.37,0,.23,1)';
const transition = `1s ${ease}`;
const opacityTransition = `0.5s ${opacityEase}`;
const distanceEase = 0.7;
const ImageContainer = ({ setup, className, style, allowOpen, delay, depth, noHeight, eventParentDepth = 3, boundingScroll, useLvh, children, }) => {
    const containerRef = useRef(null);
    const innerContainerRef = useRef(null);
    const delayedCallRef = useRef(null);
    const originalBounds = useRef();
    const allowToMeasureBounds = useRef(false);
    useEffect(() => {
        if (containerRef.current) {
            originalBounds.current = containerRef.current.getBoundingClientRect();
            // This is nasty business
            let scrollEventElement = containerRef.current.parentElement?.parentElement?.parentElement;
            if (eventParentDepth) {
                switch (eventParentDepth) {
                    case 2:
                        scrollEventElement =
                            containerRef.current.parentElement?.parentElement;
                        break;
                    case 1:
                        scrollEventElement = containerRef.current.parentElement;
                        break;
                }
            }
            scrollEventElement?.addEventListener('animation', onScroll);
        }
    }, []);
    const onScroll = (evt) => {
        if (containerRef.current) {
            const pos = evt?.detail?.pos ?? 0;
            containerRef.current.style.transition = '';
            if (!boundingScroll) {
                containerRef.current.style.transform = `translate(0, calc(${((pos * 0.5) / window.innerHeight) * (depth ?? 0)}px * var(--pageWidthNumeric)))`;
            }
            else {
                if (innerContainerRef.current) {
                    const bounds = allowToMeasureBounds.current
                        ? containerRef.current.getBoundingClientRect()
                        : originalBounds.current;
                    allowToMeasureBounds.current = true;
                    const offset = 100;
                    if (bounds.y + bounds.height > -offset &&
                        bounds.y < window.innerHeight + offset) {
                        innerContainerRef.current.style.transform = `translate(0, ${((bounds.y - window.innerHeight / 2) / 4) * (depth ?? 0) * (window.innerWidth / (isMobileWidth() ? 1600 : 2000))}px)`;
                    }
                }
            }
        }
    };
    useEffect(() => {
        if (delay !== undefined && containerRef.current) {
            if (allowOpen) {
                requestAnimationFrame(startPosition);
            }
        }
        return () => {
            if (delayedCallRef.current) {
                delayedCallRef.current.kill();
            }
        };
    }, [allowOpen]);
    const startPosition = () => {
        if (delay !== undefined && containerRef.current) {
            const centerDistance = getAnimDistance(containerRef.current);
            containerRef.current.style.transition = '';
            containerRef.current.style.willChange = 'transform, opacity';
            containerRef.current.style.transform = `translate(${centerDistance.x * distanceEase}px, ${centerDistance.y * distanceEase}px) scale(1.3)`;
            containerRef.current.style.opacity = '0';
            delayedCallRef.current = gsap.delayedCall(delay * 0.14, showImage);
        }
    };
    const showImage = () => {
        if (containerRef.current) {
            containerRef.current.style.transition = `transform ${transition}, opacity ${opacityTransition}`;
            containerRef.current.style.transform = 'scale(1)';
            containerRef.current.style.opacity = '1';
        }
    };
    const computedStyle = {
        ...getAbsoluteSetupCSS(getAbsoluteSetupArray(setup), { noHeight, useLvh }),
        ...style, // Allow overriding or extending styles via the style prop.
    };
    return (_jsx("div", { className: className, style: computedStyle, ref: containerRef, children: boundingScroll ? (_jsx("div", { className: "bounding-inner-container", ref: innerContainerRef, children: children })) : (children) }));
};
export default ImageContainer;
